import { render, staticRenderFns } from "./FichaListView.vue?vue&type=template&id=7862bc05&scoped=true&"
import script from "./FichaListView.vue?vue&type=script&lang=js&"
export * from "./FichaListView.vue?vue&type=script&lang=js&"
import style0 from "./FichaListView.vue?vue&type=style&index=0&id=7862bc05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7862bc05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VChip,
  VContainer,
  VDivider,
  VFlex,
  VIcon,
  VImg,
  VLayout,
})
